import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=407fa96a&"
import script from "./Feeds.vue?vue&type=script&lang=ts&"
export * from "./Feeds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports